// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1f40b291","774":"4ea87bec"}[chunkId] + ".chunk.js";
};